/**
 * Helper function to validate color format (HEX or RGB)
 * @param color - Color string to validate
 * @returns true if color is in valid HEX or RGB format, false otherwise
 */
const isValidColor = (color: string): boolean => {
  if (!color) return true // Optional field
  // HEX format: #RRGGBB or #RGB
  const hexPattern = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/
  // RGB format: rgb(r, g, b) or rgba(r, g, b, a)
  const rgbPattern = /^rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*[\d.]+)?\s*\)$/
  return hexPattern.test(color) || rgbPattern.test(color)
}

export const ColorUtils = {
  isValidColor,
}
